import Landing from "./Landing";
import Projects from "./Projects";

/**
 * The landing route: the original single-page experience, wrapper and all.
 * Landing is sticky and Projects overlays it, so this wrapper's classes matter.
 */
const Home = ({ setSelectedPage }) => (
  <div className="mx-auto relative">
    <Landing setSelectedPage={setSelectedPage} />
    <Projects setSelectedPage={setSelectedPage} />
    {/* Projects is the last thing in the document, so its rounded bottom
        corners cut out to whatever is painted behind - the cream `.app`
        background - and read as chipped rather than as a panel. Its rounded
        top corners have the landing behind them and are meant to show it, so
        the radius stays; this strip just gives the bottom two corners the
        off-black continuation they lack. It is a plain positioned sibling on
        purpose: ancestor backgrounds paint first, and Projects is its own
        `z-50` stacking context, so the strip lands between the two without
        needing a z-index of its own. */}
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-x-0 bottom-0 h-10 bg-off-black"
    />
  </div>
);

export default Home;
